<template>
  <v-container>
    <v-alert
      v-if="user.firstLoginCode"
      v-model="firstTimeUser"
      prominent
      type="success"
      transition="scale-transition"
    >
      <p>
        This new user's login code is <strong>{{ user.firstLoginCode }}</strong>.
        Please make note of this,
        as it will not be shown again.
      </p>
      <p>
        Username: {{ user.email }}
      </p>
      <p>
        Login Code: {{ user.firstLoginCode }}
      </p>
    </v-alert>
    <v-alert
      v-model="successDialog"
      dismissable
      prominent
      type="success"
      transition="scale-transition"
    >
      Item successfully saved!
    </v-alert>
    <v-alert
      v-model="errorDialog"
      dismissible
      prominent
      type="error"
      transition="scale-transition"
    >
      Something went wrong
    </v-alert>
    <v-card v-if="!loading">
      <v-card-title>
        <span class="headline">{{ user.email }}</span>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="user.firstName"
          label="First Name"
        />
        <v-text-field
          v-model="user.lastName"
          label="Last Name"
        />
        <v-text-field
          v-model="user.email"
          label="Email"
        />
        <phone-component
          :input="user.phone"
          @phoneSet="setPhone"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          ripple
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

import PhoneComponent from './PhoneComponent.vue';

export default {
  name: 'EditUserComponent',
  components: {
    PhoneComponent,
  },
  props: {
    userId: {
      type: String,
      default: '',
    },
    inputUser: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    firstTimeUser: false,
    user: {},
    loading: true,
    successDialog: false,
    errorDialog: false,
  }),
  mounted() {
    if (!this.inputUser && this.userId) {
      this.user = this.getUser();
    } else if (this.inputUser && this.inputUser.userId && this.inputUser.firstLoginCode) {
      this.firstTimeUser = true;
      this.user = this.inputUser;
    }
  },
  methods: {
    ...mapActions('apiClient', ['get', 'update']),
    save() {
      this.update({ url: '/users', body: this.user, id: this.user.userId }).then(
        (response) => {
          this.successDialog = true;
          this.user = response.data;
          setTimeout(() => {
            this.successDialog = false;
          }, 5000);
        },
        (error) => {
          this.errorDialog = true;
          console.log(error);
          setTimeout(() => {
            this.errorDialog = false;
          }, 5000);
        },
      );
    },
    setPhone(val) {
      this.user.phone = val;
    },
    async getUser() {
      this.loading = true;

      await this.get({ url: '/users', id: this.userId }).then(
        (response) => {
          this.user = response.data;
        },
        (error) => {
          console.log(error);
        },
      );

      this.loading = false;
    },
  },
};
</script>
